import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "workflowRow", "workflowCheckbox", "selectedCount", "summary"]

  connect() {
    this.filter()
    this.updateSummary()
  }

  filter() {
    const query = this.hasSearchInputTarget ? this.searchInputTarget.value.trim().toLowerCase() : ""

    this.workflowRowTargets.forEach((row) => {
      const show = query === "" || (row.dataset.name || "").includes(query)
      row.classList.toggle("d-none", !show)
    })
  }

  updateSummary() {
    const count = this.workflowCheckboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = `${count} selected`
      this.selectedCountTarget.classList.toggle("bg-primary", count > 0)
      this.selectedCountTarget.classList.toggle("bg-secondary", count === 0)
    }

    if (this.hasSummaryTarget) {
      this.summaryTarget.textContent = count > 0 ?
        `Selected ${count} workflow${count === 1 ? "" : "s"} to assign before sending invites.` :
        "Select any workflows you want to assign before sending invites."
    }
  }

  selectVisible() {
    this.workflowCheckboxTargets.forEach((checkbox) => {
      if (!checkbox.closest(".d-none")) checkbox.checked = true
    })
    this.updateSummary()
  }

  clearAll() {
    this.workflowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.updateSummary()
  }
}
